module.exports = __webpack_public_path__ + "img/location-pin.07562b90.svg";